import React, { Component } from "react";
import { connect } from "react-redux";
import * as sanofiActions from "../../store/actions/Index";
import * as authActions from "../../store/actions/auth";
import * as ActionTypes from "../../store/actions/ActionTypes";
import AppBar from "../../components/AppBar/AppBar";
import Container from "@material-ui/core/Container";
import SideMenu from "../../components/SideMenu/SideMenu";
import Users from "../Users/Users";
import Questions from "../Questions/Questions";

class Manager extends Component {
	state = {
		fieldValues: {
			image: ""
		},
		loading: false,
		decisionModalOpen: false,
		modifyFormModalOpen: false,
		modifyTextFormOpen: false,
		idToDelete: 0,
		idToUpdate: 0,
		deleting: false
	};

	componentDidMount() {
		this.props.onLoadUsers(this.props.token);
		this.props.loadQuestions();

	}

	handleSideMenu = () => {
		this.setState({ sideMenuOpen: !this.state.sideMenuOpen });
	};

	render() {
		const containerStyle = {
			marginTop: "50px"
		};

		let questions = this.props.questionsMenuOpen ? (
			<Questions
				questions={this.props.questions}
				loadQuestions={this.props.loadQuestions}
				loadLevels={this.props.loadLevels}
				levels = {this.props.levels}
				levelCategories ={this.props.levelCategories}
				loadLevelCategories={this.props.loadLevelCategories}
				handleSaveQuestion={this.props.saveQuestion}
				handleSaveQuestionConnect={this.props.saveQuestionConnect}
				token={this.props.token}
			/>
		) : null;

		let users = this.props.usuariosMenuOpen ? (
			<Users
				users={this.props.usersList}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadUsersGeneral={this.props.onLoadUsers}
				loadUsersMonth={this.props.onLoadUsersMonth}
				loadUsersWeek={this.props.onLoadUsersWeek}
			/>
		) : null;

		return (
			<div>
				<AppBar
					openMenu={this.props.handleOpenSideMenu}
					onClickLogout={this.props.handleLogout}
				/>
				<SideMenu
					open={this.props.sideMenuOpen}
					handleOpenUsuarios={this.props.handleOpenUsuarios}
					handleOpenQuestions={this.props.handleOpenQuestions}
				/>
				<Container fixed style={containerStyle}>
					{users}
					{questions}
				
				</Container>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		questions: state.reducer.questions,
		levels: state.reducer.levels,
		levelCategories: state.reducer.levelCategories,
		sideMenuOpen: state.reducer.sideMenuOpen,
		usuariosMenuOpen: state.reducer.usuariosMenuOpen,
		questionsMenuOpen: state.reducer.questionsMenuOpen,
		token: state.authReducer.token,
		usersList: state.reducer.users,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		loadQuestions: () => dispatch(sanofiActions.loadQuestions()),
		loadLevels: (idcategory) => dispatch(sanofiActions.loadLevels(idcategory)),
		loadLevelCategories: (idlevel) => dispatch(sanofiActions.loadLevelCategories(idlevel)),
		saveQuestion: (question) => dispatch(sanofiActions.saveQuestion(question)),
		saveQuestionConnect: (question) => dispatch(sanofiActions.saveQuestionConnect(question)),
		onLoadUsers: token => dispatch(sanofiActions.loadUsers(token)),
		onLoadUsersMonth: token => dispatch(sanofiActions.loadUsersMonth(token)),
		onLoadUsersWeek: token => dispatch(sanofiActions.loadUsersWeek(token)),
		handleOpenSideMenu: () =>
			dispatch({ type: ActionTypes.OPENCLOSE_SIDEMENU }),
		handleOpenUsuarios: () => dispatch({ type: ActionTypes.OPEN_USUARIOS }),		
		handleOpenQuestions: () => dispatch({ type: ActionTypes.OPEN_QUESTIONS }),
		handleLogout: () => dispatch(authActions.authLogOut())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
